// extracted by mini-css-extract-plugin
export default {"window":"window_message_window__tP83U","trigger_window":"window_message_trigger_window__gNFpQ","message":"window_message_message__BCeTd"};